import React, { useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import Layout from "components/Layout/Layout"
import SEO from "components/seo"
import useRecycles from "hooks/useRecycles"

import Cities from "../PageMap/components/cities"
import Filters from "../PageMap/components/Filters/Filters"
import Map from "../PageMap/components/map"
import Search from "../PageMap/components/search"
import SearchResult from "../PageMap/components/SearchResult"
import PointContent from "./components/PointContent"
import AddCompanyBlock from "./components/AddCompanyBlock/AddCompanyBlock"
import FeedbackForm from "./components/FeedbackForm/FeedbackForm"

import styles from "./PageRecycles.module.scss"

const PageRecycles = () => {
  const {
    i18n: { language },
  } = useTranslation()
  const eventsRef = useRef()
  const mapsRef = useRef()
  const { data } = useRecycles()
  const [selectedRecyclingType, setSelectedRecyclingType] = useState(null)
  const [selectedCity, setSelectedCity] = useState(null)
  const [searchValue, setSearchValue] = useState("")

  const filteredPoints = useMemo(() => {
    const boundsPoints =
      !selectedCity && !selectedRecyclingType
        ? data.points
        : data.points.filter(point => {
            const filterByType = selectedRecyclingType
              ? point.recyclingType.id === selectedRecyclingType.id
              : true
            const filterByCity = selectedCity
              ? point.city === selectedCity.city
              : true

            return filterByType && filterByCity
          })

    // if (selectedCity || selectedPromotion) {
    mapsRef.current?.zoomToBounds?.(boundsPoints)
    // }

    return boundsPoints.map(it => ({
      ...it,
      content: <PointContent data={it} />,
    }))
  }, [data, selectedCity, selectedRecyclingType])

  const filteredRecyclingTypes = useMemo(() => {
    if (!selectedCity) {
      return data.recyclingTypes
    }

    return data.recyclingTypes
      .filter(recyclingType =>
        recyclingType.locations.some(
          location => location.city === selectedCity.city
        )
      )
      .map(recyclingType => {
        const count = recyclingType.locations.filter(
          it => it.city === selectedCity.city
        ).length
        return {
          ...recyclingType,
          count,
        }
      })
  }, [data, selectedCity])

  const handleClusterClick = () => {
    eventsRef.current?.minimize?.()
  }

  const handleSearch = value => {
    setSearchValue(value)
  }

  const handleSearchResultClick = item => {
    mapsRef.current?.zoomToBounds?.([item])
  }

  return (
    <Layout footerClassName={styles.footer}>
      <SEO title="Карта технологий по переработке пищевых отходов" />
      <div className={styles.container}>
        <div className={styles.header}>
          <div>
            <h1 className={styles.title}>
              Карта технологий по переработке пищевых отходов
            </h1>
            <Cities
              cities={data.cities}
              totalCount={data.totalCount}
              onChange={setSelectedCity}
            />
          </div>
          <div className={styles.hint}>
            Выберите свой город и смотрите, какие технологии по переработке в
            нем есть
          </div>
        </div>
      </div>
      <Map
        ref={mapsRef}
        points={filteredPoints}
        onClusterClick={handleClusterClick}
        language={language}
      >
        <div className={styles.controls}>
          <Search onChange={handleSearch} placeholder="Найти адрес" />
          <SearchResult
            searchValue={searchValue}
            points={filteredPoints}
            onSelect={handleSearchResultClick}
          />
          {/*<Filters*/}
          {/*  title="Тип переработки"*/}
          {/*  allItemsTitle="Все партнеры"*/}
          {/*  ref={eventsRef}*/}
          {/*  items={filteredRecyclingTypes}*/}
          {/*  selected={selectedRecyclingType}*/}
          {/*  onChange={setSelectedRecyclingType}*/}
          {/*/>*/}
        </div>
      </Map>
      <AddCompanyBlock />
      <FeedbackForm />
    </Layout>
  )
}

export default PageRecycles
